import { useLazyQuery, useMutation } from "@apollo/client/react";
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { FormControl, Grid, InputAdornment, InputLabel, ListItemIcon, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { CustomChip } from '../../../components/chip/Chip';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { useNavigate } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { DateInput } from '../../../components/dateInput/DateInput';
import { GET_PRORROGAS } from '../../../data/graphQL/queries/Prorroga/getProrrogas';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { CREATE_PRORROGAS } from '../../../data/graphQL/mutations/Prorroga/CreateProrroga';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import './prorrogaContent.scss';
import { normalizeFilterValue } from '../../../helpers/tools';
import { formatCurrency } from "../../../utils/mathUtils";

const locale = "es-ES";
const TIPO_MODULO_SSAP = 6;

export const ProrrogaContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();
  const [prorrogas, setProrrogas] = useState([]);
  const [estados] = useState([
    { id: 1, displayName: "Entre 11 y 30 días" },
    { id: 2, displayName: "De 10 a 5 días" },
    { id: 3, displayName: "De 4 a 0 días" },
    { id: 4, displayName: "Vencido" }]
  );
  const [loadingGrabar, setLoadingGrabar] = useState(false);
  const [fechaHastaSelected, setFechaHastaSelected] = useState(null);
  const [delegaciones, setDelegaciones] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [prorrogasSelected, setProrrogasSelected] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  // Estados Paciente
  const [estadosChipPaciente] = useState({
    1: { isRed: true },
    2: { isYellow: true },
    3: { isYellow: true },
    4: { isGreen: true },
    5: { isRed: true }
  });
  // Estados
  const [estadosChip] = useState({
    1: { isGreen: true },
    2: { isViolet: true },
    3: { isYellow: true },
    4: { isRed: true }
  });
  const [datosOriginal, setDatosOriginal] = useState([]);
  const { filters, handleChangeFilters } = usePersistFilters({
    idDelegacion: delegacionOrigen,
    txtFiltro: '',
    estadoSelected: 1
  }, "prorrogaFilters");
  const disabledCheckbox = (row) => {
    return row?.bloqueoSAP ||
      !row?.planCuidadoActivo ||
      row?.condicional ||
      row?.idPlanCuidadoEstado != 3 ||
      row?.precioSAP === 0 && row?.estadoPrecio != 2 && !row?.cotizado;
  };

  const handleSelectionModelChange = (ids) => {
    setRowSelectionModel(ids);
    if (ids.length > 0) {
      setProrrogasSelected(prorrogas.filter((prorroga) => validateDiasVencimiento(prorroga.vencimiento)).filter((row, index) => {
        return ids.includes(index + 1);
      }).map((row) => {
        return {
          idEvaluacion: row.idEvaluacion,
          fechaDesde: moment(row.fechaHasta).add(1, 'd').format("yyyy-MM-DD")
        };
      }));
    } else {
      setProrrogasSelected([]);
    }
  };
  const handleCleanProrroga = () => {
    setLoadingGrabar(false);
    handleChangeFechaHasta(null);
    setProrrogasSelected([]);
    setProrrogas([]);
  };
  const getChipColor = (day) => {
    if (day < 0)
      return { isRed: true }; else
      if (day == 0 || day <= 4)
        return { isYellow: true }; else
        if (day <= 10)
          return { isViolet: true }; else

          return { isGreen: true };
  };
  const validateDiasVencimiento = (day) => {
    if (filters?.estadoSelected == 1 && day >= 11)
      return true; else
      if (filters?.estadoSelected == 2 && day >= 5 && day <= 10)
        return true; else
        if (filters?.estadoSelected == 3 && day >= 0 && day <= 4)
          return true; else
          if (filters?.estadoSelected == 4 && day < 0)
            return true; else

            return false;
  };
  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      minWidth: 40,
      width: 40,
      maxWidth: 40,
      cellClassName: 'grid-actions-column',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <VisibilityIcon sx={{ width: 22, height: 22, cursor: 'pointer', paddingTop: '8px' }} className='edit-icon-no-margin' onClick={
            () => {
              navigate('/contratos/crearContrato',
                {
                  state: {
                    idEvaluacion: row.idEvaluacion,
                    idDelegacion: filters?.idDelegacion,
                    delegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.displayName,
                    origen: row.tipo,
                    edit: false,
                    nuevoPaciente: false,
                    nuevoPacienteExistente: false,
                    descEstadoEvaluacion: row.descEstadoEvaluacion
                  }
                });
            }
          } />);

      }
    },
    {
      field: 'idEvaluacion',
      headerName: '#',
      width: 80
    },
    {
      field: 'nombre',
      headerName: 'Paciente',
      width: 220,
      valueGetter: (_, row) => {
        return row?.apellido + ', ' + row?.nombre;
      }
    },
    {
      field: 'razonSocial',
      headerName: 'Cliente',
      width: 200
    },
    {
      field: 'fechaDesde',
      type: 'date',
      headerName: 'F. Desde',
      width: 90
    },
    {
      field: 'fechaHasta',
      type: 'date',
      headerName: 'F. Hasta',
      width: 90
    },
    {
      field: 'diaParaVencer',
      headerName: 'Días para vencer',
      width: 130,
      valueGetter: (_, row) => row.vencimiento,
      renderCell: ({ row }) => {
        return (
          <Fragment>
            <div className='chip-dias-para-vencer' style={{ gap: '5px' }}>
              <CustomChip
                {...getChipColor(row?.vencimiento)} />

              <div>{row?.vencimiento}</div>
            </div>
          </Fragment>);

      }
    },
    {
      field: 'idEstadoPaciente',
      headerName: 'E. Paciente',
      width: 120,
      headerAlign: 'center',
      align: 'center',
      renderCell: ({ row: { idEstadoPaciente, descripcionEstadoPaciente } }) =>
        <CustomChip
          key={idEstadoPaciente}
          label={descripcionEstadoPaciente}
          {...estadosChipPaciente[idEstadoPaciente]} />


    },
    {
      field: 'planCuidado',
      headerName: 'Plan',
      width: 250
    },
    {
      field: 'precioDiario',
      headerName: 'Precio',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (precioDiario) => formatCurrency(precioDiario)
    },
    {
      field: 'precioSAP',
      headerName: 'Precio SAP',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (precioSAP) => formatCurrency(precioSAP)
    },
    {
      field: 'bloqueoSAP',
      headerName: 'Bloqueo SAP',
      width: 100,
      align: 'center',
      valueGetter: (bloqueoSAP) => bloqueoSAP ? 'SI' : 'NO'
    },
    {
      field: 'planCuidadoActivo',
      headerName: 'Plan Activo',
      width: 90,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (planCuidadoActivo) => planCuidadoActivo ? 'SI' : 'NO'
    },
    {
      field: 'idPlanCuidadoEstado',
      headerName: 'Plan Validado',
      width: 90,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (idPlanCuidadoEstado) => idPlanCuidadoEstado == 3 ? 'SI' : 'NO'
    },
    {
      field: 'cotizado',
      headerName: 'Cotizado',
      width: 80,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (cotizado) => cotizado ? 'SI' : 'NO'
    },
    {
      field: 'idResultadoPresupuesto',
      headerName: 'Condicional',
      width: 90,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (idResultadoPresupuesto) => idResultadoPresupuesto == 2 ? 'SI' : 'NO'
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [delegaciones, estados, filters?.idEstadoCrediticio]);

  const storageId = sessionStorage.getItem('idUsuario');

  const [getDelegaciones, { loading: delegacionesLoading, data: delegacionesData }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (!delegacionesData) return;

    setDelegaciones(adaptDelegacionArray(delegacionesData).filter((x) => x.id !== 1));
  }, [delegacionesData]);

  const [getDelegacionOrigen, { data: delegacionOrigenData }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (!delegacionOrigenData) return;

    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      setDelegacionOrigen(deleg);

      if (filters.idDelegacion == 0)
        handleChangeFilters('idDelegacion', deleg);

      getProrrogas({ variables: { idDelegacion: filters?.idDelegacion } });
    }
  }, [delegacionOrigenData]);

  useEffect(() => {
    setChildrenAction(() =>
      <div className='top-buttons'>
        <Tooltip title="Al generar la prorroga se va a estar agregando días apartir de la fecha desde.">
          <ListItemIcon className='info-icon'>
            <InfoIcon className='info-icon' style={{ fontSize: 20 }} />
          </ListItemIcon>
        </Tooltip>
        <Grid className="fecha-hasta-container" size={{ md: 1.8 }}>
          <DateInput
            key={fechaHastaSelected}
            label="Fecha Hasta"
            value={fechaHastaSelected}
            onChange={handleChangeFechaHasta} />

        </Grid>
        <CustomButton
          disabled={prorrogasSelected.length == 0 || fechaHastaSelected == null}
          onClick={() => handleClickAgregar()}
          isLoading={loadingGrabar}>

          Generar prorroga
        </CustomButton>
      </div>
    );
  }, [setChildrenAction, prorrogasSelected, fechaHastaSelected]);

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId) } });
    }
    getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId) } });
  }, [storageId]);


  const [getProrrogas, { loading: prorrogasLoading, data: prorrogasData }] = useLazyQuery(GET_PRORROGAS, { fetchPolicy: 'no-cache' });

  useEffect(() => {
    if (!prorrogasData?.prorrogas?.valorEsperado) return;

    const datos = prorrogasData.prorrogas.valorEsperado;
    setDatosOriginal(datos);
    setProrrogas(datos);
  }, [prorrogasData]);

  const [createProrrogas] = useMutation(CREATE_PRORROGAS, {
    onCompleted: (data) => {
      handleCleanProrroga();
      setTimeout(() => {
        getProrrogas({ variables: { idDelegacion: filters.idDelegacion } });
      }, 500);
      data.createProrrogas.valorEsperado ? toast.success('¡Prorrogas generadas!.') :
        toast.error('Ha ocurrido un error.');

    },
    refetchQueries: [GET_PRORROGAS]
  });

  const handleClickAgregar = () => {
    setLoadingGrabar(true);
    const input = prorrogasSelected.map((prorroga) => {
      return {
        idEvaluacion: prorroga?.idEvaluacion,
        fechaDesde: prorroga?.fechaDesde,
        fechaHasta: fechaHastaSelected
      };
    });

    createProrrogas({
      variables: {
        input: input
      }
    });
  };

  const handleTextFilter = () => {
    const inputBuscar = normalizeFilterValue(filters?.txtFiltro);

    if (inputBuscar?.length >= 2) {
      setProrrogas(datosOriginal?.filter((datoOriginal) => {
        const contratoBuscar = datoOriginal.idEvaluacion.toString();
        const planCuidado = datoOriginal.planCuidado ? datoOriginal.planCuidado.toString().toUpperCase() : '';
        const nombrePacienteBuscar = `${datoOriginal.apellido}, ${datoOriginal.nombre}`.toUpperCase();
        const clienteBuscar = datoOriginal.razonSocial.toUpperCase();
        const diasVencimiento = datoOriginal.vencimiento;

        return (
          (contratoBuscar.includes(inputBuscar) ||
            planCuidado.includes(inputBuscar) ||
            nombrePacienteBuscar.includes(inputBuscar) ||
            clienteBuscar.includes(inputBuscar)) &&
          validateDiasVencimiento(diasVencimiento));

      }));
    } else {
      setProrrogas(datosOriginal);
    }
  };

  const handleTextClean = () => {
    handleChangeFilters('txtFiltro', '');
    setProrrogas(datosOriginal);
  };

  const handleChangeFechaHasta = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : null;
    setFechaHastaSelected(nuevaFecha);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    handleChangeFilters(name, value);
  };

  const handleSearch = () => {
    if (!prorrogasLoading) {
      getProrrogas({ variables: { idDelegacion: filters.idDelegacion } });
    }
  };

  return (
    <>
      <div className='grid-container'>
        <Grid
          container
          spacing={2}
          sx={{ marginBottom: '25px' }}>

          <Grid size={{ md: 2.5 }}>
            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
              <InputLabel id="select-delegacion">Delegación</InputLabel>
              <Select
                labelId="select-delegacion"
                options={delegaciones}
                label='Delegación'
                onChange={handleChange}
                value={filters?.idDelegacion}
                name='idDelegacion'>

                {delegaciones && delegaciones.map((delegacion) => {
                  return <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ md: 2.5 }}>
            <TextField
              label="Filtrar"
              name="txtFiltro"
              size="small"
              type="text"
              fullWidth
              variant="outlined"
              value={filters?.txtFiltro}
              onChange={(e) => handleChangeFilters('txtFiltro', e.target.value)}
              onKeyUp={handleTextFilter}
              sx={{ backgroundColor: 'white' }}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <SearchIcon
                      onClick={handleTextFilter}
                      sx={{ cursor: 'pointer' }} />

                    <ClearIcon
                      onClick={handleTextClean}
                      sx={{ cursor: 'pointer' }} />

                  </InputAdornment>

              }} />

          </Grid>
          <Grid size={{ xs: 3.5 }}>
            <FormControl
              fullWidth
              variant='outlined'
              size='small'>

              <InputLabel>{'Días para vencer'}</InputLabel>
              <Select
                fullWidth
                variant='outlined'
                size='small'
                label='Días para vencer'
                className='select-type-input'
                value={filters?.estadoSelected}
                onChange={(e) => {
                  handleChangeFilters('estadoSelected', e.target.value);
                }}
                renderValue={() => { return estados.find((option) => option.id === filters?.estadoSelected)?.displayName; }}>

                {estados?.map(({ id, displayName }, index) =>
                  <MenuItem
                    key={`${index}${displayName}`}
                    className='select-input-menu-item'
                    value={id}
                    dense>

                    <div className='chip-dias-para-vencer'
                      key={id}>

                      <CustomChip
                        {...estadosChip[id]}
                        key={id} />

                    </div>
                    {displayName}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ md: 2.5 }}>
          </Grid>
          <Grid className='input-buscar' sx={{ textAlign: 'right' }} size={{ md: 1 }}>
            <CustomButton
              variant='contained'
              onClick={handleSearch}
              size='small'>

              Buscar
            </CustomButton>
          </Grid>
        </Grid>
        <DataGridGenerico
          columns={columns}
          rows={prorrogas.filter((prorroga) => validateDiasVencimiento(prorroga.vencimiento))}
          toolbar={false}
          loading={prorrogasLoading}
          checkboxSelection={true}
          isRowSelectable={(param) => !disabledCheckbox(param.row)}
          onRowSelectionModelChange={handleSelectionModelChange}
          rowSelectionModel={rowSelectionModel}
          maxWidth={columns.reduce((total, column) => total + (column.width || 0), 0)} />

      </div>
    </>);

};